import { useCallback, useState } from "react";

import { AppEvent } from "../types";
import { getTabId, getUserId } from "../utils/localStorage";

interface LogEvent {
    timestamp: string;
    userId: string;
    tabId: string;
    event: AppEvent;
    payload?: unknown;
}

export function useLogging() {
    const [logs, setLogs] = useState<LogEvent[]>([]);

    const logWithPayload = useCallback((appEvent: AppEvent, payload: unknown) => {
        const event: LogEvent = {
            timestamp: new Date().toISOString(),
            userId: getUserId(),
            tabId: getTabId(),
            event: appEvent,
            payload,
        };
        console.log(event);
        setLogs((prevLogs) => [...prevLogs, event]);
    }, []);

    const log = useCallback(
        (appEvent: AppEvent) => {
            logWithPayload(appEvent, undefined);
        },
        [logWithPayload],
    );

    return {
        logWithPayload,
        log,
        logs,
    };
}
